<template>
  <card card-body-classes="table-full-width">
    <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <h4 slot="header" class="card-title">{{ $t('accountTopUp.title') }}</h4>
    </div>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page"
        >
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>

        <div class="row">
          <div class="col-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"
              >
              </el-input>
            </base-input>
          </div>

        </div>
      </div>

      <el-table v-loading="loading" :data="queriedData" :row-class-name="tableRowClassName" :empty-text="$t('generic.noData')">
        <el-table-column type="expand">
          <template slot-scope="props">
            <top-up-details :details="props.row"/>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :prop="column.prop"
          :label="$t(column.label)"
          :formatter="column.formatter"
          :min-width="column.minWidth"
          :width="column.width"
        >
        </el-table-column>
        <el-table-column align="right" width="50">
          <div slot-scope="props">
            <router-link
              :to="{name: 'account-top-ups-details', params: {id: props.row.account_id, top_up_id: props.row.id}}">
              <i v-if="props.row.status == 'started'" class="tim-icons icon-pencil"></i>
              <i v-else class="tim-icons icon-double-right"></i>
            </router-link>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{ $t('generic.tablePaginationSummary', {from: from + 1, to: to, total: total}) }}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import {Option, Select, Table, TableColumn} from 'element-ui';
import {BaseAlert, BasePagination} from 'src/components';
import Fuse from 'fuse.js';
import {mapActions, mapState} from "vuex";
import TopUpDetails from 'src/components/TopUp/TopUpDetails'

export default {
  name: 'AccountTopUps',
  components: {
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    TopUpDetails
  },
  methods: {
    ...mapActions(['GetUserTopUps']),
    tableRowClassName({row}) {
      if (row["status"] === "failed" || row["status"] === "initiation_failed") {
        return 'bg-warning';
      }
      return '';
    },
  },
  computed: {
    ...mapState({
      loading: state => state.account_top_ups.loading,
    }),
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      propsToSearch: ['amount', 'created_at', 'processed_at', 'status'],
      tableColumns: [
        {
          prop: 'created_at',
          label: 'generic.created',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
          width: 200,
        },
        {
          prop: 'status',
          label: 'generic.status',
          width: 100,
        },
        {
          prop: 'type',
          label: 'generic.type',
          width: 200,
        },
        {
          prop: 'applied_at',
          label: 'topUp.details.applied_at',
          formatter: (row, column, cellValue, index) => {
            return cellValue ? this.$options.filters.time(cellValue) : ""
          },
          width: 200,
        },
        {
          prop: 'amount',
          label: 'topUp.details.amount',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.price(cellValue)
          },
          width: 100,
        },
        {
          prop: 'merchant_reference',
          label: 'topUp.details.merchant_reference',
        },
        {
          prop: 'payment_reference',
          label: 'topUp.details.payment_reference',
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  mounted() {
    this.GetUserTopUps(this.$route.params.id)
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
    "$store.state.account_top_ups.data"(topups) {
      this.tableData = topups;
      // Fuse search initialization.
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ['amount', 'merchant_reference', 'status'],
        threshold: 0.3
      });
    }
  }
};
</script>
